import { getCookie, setCookie, delCookie } from '@utiljs/cookie';
import { setStorage } from '@utils/localStorage';
import { CUSTOM_METRICS, reportCustomMetrics } from '@utils/owlReporter';
import * as Ids from '@utils/ids';
import mtdpmapCleaner from '@utils/quotaManage/cleaner/mtdpmap';

let autoAcceptWmPoiListUpdateTs = 0;
let cachedAutoAcceptWmPoiList: string[] = [];

/** 从 localStorage 中读取自动接单门店列表 */
const updateCachedAutoAcceptWmPoiList = () => {
    // eslint-disable-next-line waimaie/no-direct-access-localstorage
    const autoAcceptWmPois = localStorage.getItem('autoAcceptWmPoiList') || '';
    if (!autoAcceptWmPois) {
        cachedAutoAcceptWmPoiList = [];
    }
    cachedAutoAcceptWmPoiList = autoAcceptWmPois.split(',');
};

/**
 * 查询门店是否在本机开启了自动接单
 *
 * @param wmPoiId 门店ID
 */
const ifPoiEnableAutoAcceptLocally = (wmPoiId: string) => {
    const currentTs = new Date().getTime();
    // 缓存2分钟，避免大连锁账号频繁进行同步的 localStorage 读
    if (
        autoAcceptWmPoiListUpdateTs === 0 ||
        currentTs - autoAcceptWmPoiListUpdateTs > 1000 * 60 * 2
    ) {
        updateCachedAutoAcceptWmPoiList();
        autoAcceptWmPoiListUpdateTs = currentTs;
    }
    try {
        if (wmPoiId === '13055431' || Ids.getWmPoiId() === '13055431') {
            reportCustomMetrics(
                CUSTOM_METRICS.ORDER_DELAY.KEY,
                1,
                {
                    [CUSTOM_METRICS.ORDER_DELAY.TAGS.TYPE]: 'ifPoiEnableAutoAcceptLocally',
                },
                {
                    cachedAutoAcceptWmPoiList: cachedAutoAcceptWmPoiList.join(','),
                    wmPoiId,
                },
            );
        }
    } catch (e) {
        //
    }
    return cachedAutoAcceptWmPoiList.includes(wmPoiId);
};

/**
 * TODO 挂载 windows
 * 切换门店
 *
 * @param wmPoiId 门店ID
 * @param wmPoiName 门店名
 * @param jumpUrl
 * @param status
 */
const selectCurrentPoi = function(
    wmPoiId: string,
    wmPoiName: string,
    jumpUrl?: string,
    status?: number,
) {
    const nowPoiId = getCookie('wmPoiId');
    // 增加setStorage失败兜底
    try {
        if (nowPoiId !== wmPoiId) {
            setStorage('fromPoiChange', 'true');
        }
    } catch (error) {
        // 增加localstorage满了上报
        reportCustomMetrics(CUSTOM_METRICS.SET_LOCAL_STORAGE_FAIL.KEY, 1, {
            [CUSTOM_METRICS.SET_LOCAL_STORAGE_FAIL.TAGS.ACCTID]: Ids.getAcctId(),
            [CUSTOM_METRICS.SET_LOCAL_STORAGE_FAIL.TAGS.TYPE]: mtdpmapCleaner.hasMTDPMap()
                ? 'mtdpmap'
                : 'other',
        });
        // 访问过一次带有地图的页面就会在storage中写入mtdpmap相关缓存。清除地图页面访问时会再重新加载不影响使用。
        mtdpmapCleaner.cleanUp();
    }

    if (Number(wmPoiId) < 0) {
        setCookie('wmPoiId', wmPoiId, {
            expires: new Date(new Date().getTime() + 1000 * 3600 * 24 * 30),
        });
        delCookie('');
        window.location.reload();
        return;
    }

    //改变isOfflineSelfOpen的值 (是否自入驻)
    setCookie('isOfflineSelfOpen', status === 0 ? '1' : '0');
    // $('#select_poi_button_text').text(wmPoiName);
    setCookie('wmPoiId', wmPoiId, {
        expires: new Date(new Date().getTime() + 1000 * 3600 * 24 * 30),
    });

    //临时添加
    setCookie('wmPoiName', wmPoiName);
    setCookie('shopCategory', '');
    setCookie('logistics_support', '');
    if (jumpUrl) {
        document.location.hash = jumpUrl;
    } else {
        const hash = window.location.hash.substr(1);
        const url = hash.split('?')[0];
        if (url.match('/reuse/product/medicine/r/list')) {
            document.location.hash = '/foods/list';
        }
    }
    window.location.reload();
};

(window as any).selectCurrentPoi = selectCurrentPoi;

export { ifPoiEnableAutoAcceptLocally, selectCurrentPoi };
